import { useMemo as r } from "react";
const e = (t, n) => {
  if (t != null) {
    if (typeof t == "function") {
      t(n);
      return;
    }
    try {
      t.current = n;
    } catch {
      throw new Error(`Cannot assign value '${n}' to ref '${t}'`);
    }
  }
}, s = (...t) => (n) => {
  t.forEach((o) => {
    e(o, n);
  });
}, u = (...t) => r(() => s(...t), t);
export {
  u as default
};
//# sourceMappingURL=useMergeRefs.js.map
